module.exports = __webpack_public_path__ + "static/media/bakasable.fd98e4c3.png";